import AXIOS from "./_axios"
import { ISignupRequest } from "../types/ISignupRequest"
import { ISigninRequest } from "../types/ISigninRequest"
import { ICompanyBank, IFullCompanyDto } from "../types/company/IFullCompanyDto"
import { IFloatingRateDto } from "../types/company/IFloatingRateDto"
import { IUpdateProfileDto } from "../types/user/IUpdateProfileDto"
import { IInnRegistryDto } from "../types/inn/IInnRegistryDto"
import { IBrockmanBankDto } from "../types/brockman/IBrockmanBankDto"
import { IBrockmanDetailDto } from "../types/brockman/IBrockmanDetailDto"
import { IClientContractorDto } from "../types/contractor/IClientContractorDto"
import { IClientContractorAccountDto } from "../types/contractor/IClientContractorAccountDto"
import { IValidatedRequestList } from "../types/IValidatedRequestList"
import { IClientRequestDto } from "../types/request/IClientRequestDto"
import { IClientRequestStatusDto } from "../types/request/IClientRequestStatusDto"
import { IReplenishmentDto } from "../types/replenishment/IReplenishmentDto"
import { ICreateMessageRequest } from "../types/messenger/ICreateMessageRequest"
import { IOrderDto } from "../types/order/IOrderDto"
import { ICalculateReplenishmentDto } from "../types/replenishment/ICalculateReplenishmentDto"
import { IProfileDto } from "../types/user/IProfileDto"
import { IClientCurrencyRate } from "../types/client/IClientCurrencyRate"
import { BalanceHistoryFilters, BalanceHistoryUploadFormData } from "@/types/balances"
import {
  ICurrencyReplenishmentCredit,
  ICurrencyReplenishmentDto
} from "@/types/replenishment/ICurrencyReplenishmentDto"
import { IExchangeDto, IExchangeQueryProps } from "@/types/exchange/IExchangeDto"

export function signUp(signupRequest: ISignupRequest, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/auth/signup`, signupRequest).then(response => {
    _callback(response)
  })
}

export function signIn(signinRequest: ISigninRequest, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.post(`/trinity/api/v1/auth/signin`, signinRequest)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function confirm(userId: number, confirmation: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/auth/confirm/${userId}/${confirmation}`).then(response => {
    _callback(response)
  })
}

export function sendResetCode(request: any, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.post(`/trinity/api/v1/auth/send-reset`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function resetPassword(request: any, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/auth/reset`, request).then(response => {
    _callback(response)
  })
}

export function changePassword(request: any, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/auth/password`, request).then(response => {
    _callback(response)
  })
}

export function suggestCountry(country: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/dict/country?country=${country}`).then(response => {
    _callback(response)
  })
}

export function suggestCurrency(currency: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/dict/currency?currency=${currency}`).then(response => {
    _callback(response)
  })
}

export function suggestSwift(swift: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/dict/swift?swift=${swift}`).then(response => {
    _callback(response)
  })
}

export function getBaseSettings() {
  return AXIOS.get("/trinity/api/v1/settings")
}

export function createBaseSettings(settings: any, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.post("/trinity/api/v1/settings", settings)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getBaseRate(type: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/rate?type=${type}`).then(response => {
    _callback(response)
  })
}

export function createBaseRate(rate: IFloatingRateDto, _callback: (response: any) => void) {
  AXIOS.post("/trinity/api/v1/rate", rate).then(response => {
    _callback(response)
  })
}

export function deleteBaseRate(rateId: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/rate/${rateId}`).then(response => {
    _callback(response)
  })
}

export function getCompany(id: string, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.get(`/trinity/api/v1/company/${id}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function createCompany(request: IFullCompanyDto, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.post(`/trinity/api/v1/company`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function updateCompany(request: IFullCompanyDto, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.put(`/trinity/api/v1/company`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getCompanyList(_callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.get(`/trinity/api/v1/company`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getCompanyBalance(companyId: string, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.get(`/trinity/api/v1/company/${companyId}/balance`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getInvoicesHistory(
  page: number,
  filters: BalanceHistoryFilters,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.post(`/trinity/api/v1/bank-statement/search`, {
    ...filters,
    page,
    pageSize: 10
  })
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function uploadInvoicesHistory(
  request: BalanceHistoryUploadFormData,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.post(`/trinity/api/v1/bank-statement/upload`, {
    ...request,
    force: request.force || false
  })
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function deleteInvoicesHistory(invoiceId: number, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.delete(`/trinity/api/v1/bank-statement/${invoiceId}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function removeCompany(companyId: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/company/${companyId}`).then(response => {
    _callback(response)
  })
}

export function getCompanyBank(
  companyId: string,
  bankId: string,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.get(`/trinity/api/v1/company/${companyId}/bank/${bankId}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function createCompanyBank(request: ICompanyBank, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.post(`/trinity/api/v1/company/${request.companyId}/bank`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function updateCompanyBank(request: ICompanyBank, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.put(`/trinity/api/v1/company/${request.companyId}/bank`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function removeCompanyBank(companyId: string, bankId: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/company/${companyId}/bank/${bankId}`).then(response => {
    _callback(response)
  })
}

export function createCurrencyPayerBank(
  request: ICompanyBank,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.post(`/trinity/api/v1/currency-payer/bank`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function updateCurrencyPayerBank(
  request: ICompanyBank,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.put(`/trinity/api/v1/currency-payer/bank`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function removeCurrencyPayerBank(bankId: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/currency-payer/bank/${bankId}`).then(response => {
    _callback(response)
  })
}

export function getFloatingRates(companyId: string, bankId: string, type: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/company/${companyId}/bank/${bankId}/rate?type=${type}`).then(response => {
    _callback(response)
  })
}

export function getClientFloatingRates(type: string, _callback: (response: any) => void, userId?: number) {
  AXIOS.get(`/trinity/api/v1/client/rate?type=${type}${userId ? `&clientId=${userId}` : ""}`).then(response => {
    _callback(response)
  })
}

export function createFloatingRate(
  companyId: string,
  bankId: string,
  rate: IFloatingRateDto,
  _callback: (response: any) => void
) {
  AXIOS.post(`/trinity/api/v1/company/${companyId}/bank/${bankId}/rate`, rate).then(response => {
    _callback(response)
  })
}

export function createClientFloatingRate(clientId: number, rate: IFloatingRateDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/client/rate`, rate).then(response => {
    _callback(response)
  })
}

export function deleteFloatingRate(
  companyId: string,
  bankId: string,
  rateId: string,
  _callback: (response: any) => void
) {
  AXIOS.delete(`/trinity/api/v1/company/${companyId}/bank/${bankId}/rate/${rateId}`).then(response => {
    _callback(response)
  })
}

export function deleteClientFloatingRate(rateId: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/client/rate/${rateId}`).then(response => {
    _callback(response)
  })
}

export function createUser(request: IProfileDto, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.post(`/trinity/api/v1/user`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getProfile(_callback: (response: any) => void, id?: number | undefined) {
  AXIOS.get(`/trinity/api/v1/profile${id ? `/${id}` : ""}`).then(response => {
    _callback(response)
  })
}

export function updateProfile(
  request: IUpdateProfileDto | undefined,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.put(`/trinity/api/v1/profile`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getUserList(
  role: string,
  page: number,
  search: string,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.get(`/trinity/api/v1/user?role=${role}&page=${page}&search=${encodeURIComponent(search)}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getUserBalances(userId: number, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.get(`/trinity/api/v1/client/balance/${userId}/all`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getUser(id: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/user/${id}`).then(response => {
    _callback(response)
  })
}

export function getAdminUserBalances(id: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/client/balance/${id}/all`).then(response => {
    _callback(response)
  })
}

export function banUser(userId: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/user/${userId}/ban`).then(response => {
    _callback(response)
  })
}

export function removeUser(userId: number, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/user/${userId}`).then(response => {
    _callback(response)
  })
}

export function getInnList(page: number, search: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/inn-registry?page=${page}&search=${encodeURIComponent(search)}`).then(response => {
    _callback(response)
  })
}

export function getCurrencyInnList(page: number, search: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/currency-payer?page=${page}&search=${encodeURIComponent(search)}`).then(response => {
    _callback(response)
  })
}

export function createCurrencyInnRegistryItem(request: IInnRegistryDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/currency-payer`, request).then(response => {
    _callback(response)
  })
}

export function updateCurrencyInnRegistryItem(request: IInnRegistryDto, _callback: (response: any) => void) {
  AXIOS.put(`/trinity/api/v1/currency-payer`, request).then(response => {
    _callback(response)
  })
}

export function deleteCurrencyInnRegistryItem(id: number, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/currency-payer/${id}`).then(response => {
    _callback(response)
  })
}

export function approveCurrencyInnRegistryItem(id: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/currency-payer/${id}/approve?action=true`).then(response => {
    _callback(response)
  })
}

export function blockCurrencyInnRegistryItem(id: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/currency-payer/${id}/approve?action=false`).then(response => {
    _callback(response)
  })
}

export function getInnRegistryByInn(inn: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/inn-registry/${inn}`).then(response => {
    _callback(response)
  })
}

export function createInnRegistryItem(request: IInnRegistryDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/inn-registry`, request).then(response => {
    _callback(response)
  })
}

export function changeCurrencyInnRegistryItemStatus(
  id: number,
  request: IInnRegistryDto,
  _callback: (response: any) => void
) {
  AXIOS.put(`/trinity/api/v1/currency-request/${id}/status`, request).then(response => {
    _callback(response)
  })
}

export function deleteInnRegistryItem(inn: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/inn-registry/${inn}`).then(response => {
    _callback(response)
  })
}

export function suggestInn(inn: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/dict/inn?inn=${inn}`).then(response => {
    _callback(response)
  })
}

export function suggestBic(bic: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/dict/bic?bic=${bic}`).then(response => {
    _callback(response)
  })
}

export function createBrockmanBank(
  request: IBrockmanBankDto,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.post(`/trinity/api/v1/brockman/bank`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function updateBrockmanBank(
  request: IBrockmanBankDto,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.put(`/trinity/api/v1/brockman/bank`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function removeBrockman(id: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/brockman/${id}`).then(response => {
    _callback(response)
  })
}

export function getBrockmanBanks(_callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/brockman`).then(response => {
    _callback(response)
  })
}

export function getBrockmanBank(id: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/brockman/${id}`).then(response => {
    _callback(response)
  })
}

export function updateBrockmanDetail(request: IBrockmanDetailDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/brockman/${request.brockmanBankId}/detail`, request).then(response => {
    _callback(response)
  })
}

export function getCbrUSD(_callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/dict/cbr-usd`).then(response => {
    _callback(response)
  })
}

export function getCurrencyCbr(_callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.get(`/trinity/api/v1/dict/currency/cbr`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getCurrencyBca(_callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.get(`/trinity/api/v1/dict/currency/bca`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function switchToUser(userId: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/auth/signin-as/${userId}`).then(response => {
    _callback(response)
  })
}

export function updateCurrencyCbr() {
  return AXIOS.delete(`/trinity/api/v1/dict/currency/cbr`)
}

export function updateCurrencyBca() {
  return AXIOS.delete(`/trinity/api/v1/dict/currency/bca`)
}

export function getClientContractors(_callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.get(`/trinity/api/v1/client/contractor`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getClientContractor(id: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/client/contractor/${id}`).then(response => {
    _callback(response)
  })
}

export function getContractorTemplates(id: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/client/contractor/${id}/template`).then(response => {
    _callback(response)
  })
}

export function deleteContractorTemplate(contractorId: string, templateId: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/client/contractor/${contractorId}/template/${templateId}`).then(response => {
    _callback(response)
  })
}

export function createClientContractor(request: IClientContractorDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/client/contractor`, request).then(response => {
    _callback(response)
  })
}

export function updateClientContractor(request: IClientContractorDto, _callback: (response: any) => void) {
  AXIOS.put(`/trinity/api/v1/client/contractor`, request).then(response => {
    _callback(response)
  })
}

export function deleteClientContractor(id: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/client/contractor/${id}`).then(response => {
    _callback(response)
  })
}

export function updateClientContractorAccounts(
  id: string,
  request: IValidatedRequestList<IClientContractorAccountDto>,
  _callback: (response: any) => void
) {
  AXIOS.post(`/trinity/api/v1/client/contractor/${id}/account`, request).then(response => {
    _callback(response)
  })
}

export function deleteClientContractorAccount(id: string, accountId: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/client/contractor/${id}/account/${accountId}`).then(response => {
    _callback(response)
  })
}

export function createClientInn(request: IInnRegistryDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/client/inn`, request).then(response => {
    _callback(response)
  })
}

export function getClientInnList(page: number, search: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/client/inn?page=${page}&search=${encodeURIComponent(search)}`).then(response => {
    _callback(response)
  })
}

export function deleteClientInn(inn: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/client/inn/${inn}`).then(response => {
    _callback(response)
  })
}

export function getClientCurrencyInnList(page: number, search: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/currency-payer?page=${page}&search=${encodeURIComponent(search)}`).then(response => {
    _callback(response)
  })
}

export function createClientCurrencyInn(request: IInnRegistryDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/currency-payer`, request).then(response => {
    _callback(response)
  })
}

export function deleteClientCurrencyInn(inn: number, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/currency-payer/${inn}`).then(response => {
    _callback(response)
  })
}

export function createClientRequest(request: IClientRequestDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/request`, request).then(response => {
    _callback(response)
  })
}

export function getClientRequests(
  page: number,
  status: string,
  search: string,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.get(`/trinity/api/v1/request?page=${page}&status=${status}&&search=${encodeURIComponent(search)}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function createClientCurrencyRequest(request: IClientRequestDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/currency-request`, request).then(response => {
    _callback(response)
  })
}

export function getClientCurrencyRequests(
  page: number,
  status: string,
  search: string,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.get(`/trinity/api/v1/currency-request?page=${page}&status=${status}&&search=${encodeURIComponent(search)}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getClientRequest(id: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/request/${id}`).then(response => {
    _callback(response)
  })
}

export function getClientCurrencyRequest(id: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/currency-request/${id}`).then(response => {
    _callback(response)
  })
}

export function changeClientRequestStatus(
  id: number,
  request: IClientRequestStatusDto,
  _callback: (response: any) => void
) {
  AXIOS.put(`/trinity/api/v1/request/${id}/status`, request).then(response => {
    _callback(response)
  })
}

export function deleteClientRequest(id: number, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/request/${id}`).then(response => {
    _callback(response)
  })
}

export function downloadFile(id: string, type: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/download?id=${id}&type=${type}`).then(response => {
    _callback(response)
  })
}

export function getReplenishmentList(status: string, _callback: (response: any) => void, onFinal?: () => void, sortByDoneDate?: string) {
  const url = sortByDoneDate
    ? `/trinity/api/v1/replenishment?status=${status}&sortByDoneDate=${sortByDoneDate}`
    : `/trinity/api/v1/replenishment?status=${status}`
  AXIOS.get(url)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getCurrencyReplenishmentList(status: string, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.get(`/trinity/api/v1/currency-replenishment?status=${status}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getReplenishment(id: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/replenishment/${id}`).then(response => {
    _callback(response)
  })
}

export function getCurrencyReplenishment(id: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/currency-replenishment/${id}`).then(response => {
    _callback(response)
  })
}

export function deleteReplenishment(id: number, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/replenishment/${id}`).then(response => {
    _callback(response)
  })
}

export function submitBasis(request: IReplenishmentDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/replenishment`, request).then(response => {
    _callback(response)
  })
}

export function createClientCurrencyReplenisment(
  request: ICurrencyReplenishmentDto,
  _callback: (response: any) => void
) {
  AXIOS.post(`/trinity/api/v1/currency-replenishment`, request).then(response => {
    _callback(response)
  })
}

export function submitCurrencyDocs(request: ICurrencyReplenishmentDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/currency-replenishment/docs`, request).then(response => {
    _callback(response)
  })
}

export function submitContractor(request: IReplenishmentDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/replenishment/contractor`, request).then(response => {
    _callback(response)
  })
}

export function submitDocs(request: IReplenishmentDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/replenishment/docs`, request).then(response => {
    _callback(response)
  })
}

export function checkDocs(request: IReplenishmentDto, accepted: boolean, _callback: (response: any) => void) {
  AXIOS.patch(`/trinity/api/v1/replenishment/${request.id}?accepted=${accepted}`, request).then(response => {
    _callback(response)
  })
}

export function updateReplenishmentComment(id: number, comment: string, _callback?: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/replenishment/${id}/comment?value=${comment}`).then(response => {
    _callback?.(response)
  })
}

export function requestCR(
  request: IReplenishmentDto,
  isAuto: boolean,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.post(`/trinity/api/v1/replenishment/cr-request?isAuto=${isAuto}`, request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function createUpdateTemplate(id: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/replenishment/${id}/template`).then(response => {
    _callback(response)
  })
}

export function calculateFloatingRate(
  userId: number,
  companyId: string | undefined,
  bankId: string | undefined,
  amount: number,
  _callback: (response: any) => void
) {
  AXIOS.get(
    `/trinity/api/v1/company/${companyId}/bank/${bankId}/rate/calculate?amount=${amount}&userId=${userId}`
  ).then(response => {
    _callback(response)
  })
}

export function calculateReplenishment(
  request: ICalculateReplenishmentDto,
  calculationMethod: string,
  _callback: (response: any) => void
) {
  AXIOS.post(`/trinity/api/v1/replenishment/calculate?calculationMethod=${calculationMethod}`, request).then(
    response => {
      _callback(response)
    }
  )
}

export function calculateExchangeRate(request: IExchangeDto, _callback: (response: any) => void) {
  AXIOS.post("/trinity/api/v1/exchange/calculate", request).then(response => {
    _callback(response)
  })
}

export function exchangeUserBalance(request: IExchangeDto, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.post("/trinity/api/v1/exchange", request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function getUserExchangeHistory(
  request: IExchangeQueryProps,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.post("/trinity/api/v1/exchange/search", request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function rollBackUserExchange(id: number, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.delete(`/trinity/api/v1/exchange/${id}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function calculateCurrencyReplenishment(
  request: ICurrencyReplenishmentCredit,
  _callback: (response: any) => void
) {
  AXIOS.post("/trinity/api/v1/currency-replenishment/calculate", request).then(response => {
    _callback(response)
  })
}

export function responseCR(request: IReplenishmentDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/replenishment/cr-response`, request).then(response => {
    _callback(response)
  })
}

export function crConfirmation(id: number, accepted: boolean, _callback: (response: any) => void) {
  AXIOS.patch(`/trinity/api/v1/replenishment/${id}/cr-confirm?accepted=${accepted}`).then(response => {
    _callback(response)
  })
}

export function submitPayment(request: IReplenishmentDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/replenishment/payment`, request).then(response => {
    _callback(response)
  })
}

export function acceptPayment(id: number, amount: number, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.patch(`/trinity/api/v1/replenishment/${id}/payment?amount=${amount}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function acceptCurrencyPayment(
  request: ICurrencyReplenishmentCredit,
  _callback: (response: any) => void,
  onFinal?: () => void
) {
  AXIOS.post("/trinity/api/v1/currency-replenishment/credit", request)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function cancelPayment(id: number, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.delete(`/trinity/api/v1/replenishment/${id}/payment`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function crFixation(request: IReplenishmentDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/replenishment/cr-fix`, request).then(response => {
    _callback(response)
  })
}

export function rollbackStatus(id: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/replenishment/${id}/rollback`).then(response => {
    _callback(response)
  })
}

export function getBalance(_callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/client/balance`).then(response => {
    _callback(response)
  })
}

export function getUnreadConversations(type: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/messenger/check?type=${type}`).then(response => {
    _callback(response)
  })
}

export function getActionsRequired(_callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/messenger/check/instances`).then(response => {
    _callback(response)
  })
}

export function getConversation(type: string, instanceId: string, page: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/messenger/${type}/${instanceId}?page=${page}`).then(response => {
    _callback(response)
  })
}

export function sendMessage(request: ICreateMessageRequest, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/messenger/message`, request).then(response => {
    _callback(response)
  })
}

export function getOrderList(status: string, _callback: (response: any) => void, onFinal?: () => void) {
  AXIOS.get(`/trinity/api/v1/order?status=${status}`)
    .then(response => {
      _callback(response)
    })
    .finally(() => onFinal?.())
}

export function submitOrder(request: IOrderDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order`, request).then(response => {
    _callback(response)
  })
}

export function getOrder(id: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/order/${id}`).then(response => {
    _callback(response)
  })
}

export function deleteOrder(id: number, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/order/${id}`).then(response => {
    _callback(response)
  })
}

export function getClientBalance(id: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/client/balance/${id}`).then(response => {
    _callback(response)
  })
}

export function payOrder(request: IOrderDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order/pay`, request).then(response => {
    _callback(response)
  })
}

export function requestSwift(id: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order/${id}/swift`).then(response => {
    _callback(response)
  })
}

export function requestInquiry(id: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order/${id}/inquiry`).then(response => {
    _callback(response)
  })
}

export function updateOrderComment(id: number, comment: string, _callback?: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order/${id}/comment?value=${comment}`).then(response => {
    _callback?.(response)
  })
}

export function responseInquiry(request: IOrderDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order/inquiry`, request).then(response => {
    _callback(response)
  })
}

export function responseSwift(request: IOrderDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order/swift`, request).then(response => {
    _callback(response)
  })
}

export function responseInquirySwift(request: IOrderDto, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order/inquiry-swift`, request).then(response => {
    _callback(response)
  })
}

export function changeOrderCompany(orderId: number, companyId: string | null, _callback: (response: any) => void) {
  AXIOS.patch(`/trinity/api/v1/order/${orderId}/company/${companyId}`).then(response => {
    _callback(response)
  })
}

export function changeOrderBank(orderId: number, bankId: string | null, _callback: (response: any) => void) {
  AXIOS.patch(`/trinity/api/v1/order/${orderId}/bank/${bankId}`).then(response => {
    _callback(response)
  })
}

export function refundOrder(orderId: number, amount: string, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order/${orderId}/refund?amount=${amount}`).then(response => {
    _callback(response)
  })
}

export function rollbackOrder(orderId: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/order/${orderId}/rollback`).then(response => {
    _callback(response)
  })
}

export function getClientManagers(id: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/profile/${id}/client-manager`).then(response => {
    _callback(response)
  })
}

export function suggestClientManagers(id: number, query: string, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/profile/${id}/client-manager/suggest?query=${query}`).then(response => {
    _callback(response)
  })
}

export function addClientManagers(userId: number, clientManagerUserId: number, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/profile/${userId}/client-manager/${clientManagerUserId}`).then(response => {
    _callback(response)
  })
}

export function removeClientManagers(userId: number, clientManagerId: number, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/profile/${userId}/client-manager/${clientManagerId}`).then(response => {
    _callback(response)
  })
}

export function getClientCurrencyRates(userId: number, _callback: (response: any) => void) {
  AXIOS.get(`/trinity/api/v1/client/currency-rate?clientId=${userId}`).then(response => {
    _callback(response)
  })
}

export function deleteClientCurrencyRate(id: string, _callback: (response: any) => void) {
  AXIOS.delete(`/trinity/api/v1/client/currency-rate/${id}`).then(response => {
    _callback(response)
  })
}

export function createClientCurrencyRate(rate: IClientCurrencyRate, _callback: (response: any) => void) {
  AXIOS.post(`/trinity/api/v1/client/currency-rate`, rate).then(response => {
    _callback(response)
  })
}

export function downloadOrderTxt(id: number, _callback: (response: any) => void, _onError?: () => void) {
  AXIOS.get(`/trinity/api/v1/order/${id}/unload/txt`, { responseType: "blob" })
    .then(response => {
      _callback(response)
    })
    .catch(() => {
      _onError?.()
    })
}
